import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { WeeklyTrend } from '@/services/admin/adminPrivilegedService';

interface UserRegistrationsChartProps {
  weeklyTrends?: WeeklyTrend[];
}

const UserRegistrationsChart: React.FC<UserRegistrationsChartProps> = ({ weeklyTrends }) => {
  const chartData = weeklyTrends?.slice().reverse().map(trend => ({
    week: new Date(trend.weekStart).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
    newUsers: trend.newUsers
  })) || [];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">New User Registrations</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="week" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="newUsers" fill="#059669" />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default UserRegistrationsChart;